module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "item",
    staticClass: "vue-grid-item",
    class: {
      'vue-resizable': _vm.isItemResizable, 'resizing': _vm.isResizing, 'vue-draggable-dragging': _vm.isDragging, 'cssTransforms': _vm.useCssTransforms
    },
    style: (_vm.style)
  }, [_vm._t("default"), _vm._v(" "), (_vm.isItemResizable) ? _c('span', {
    ref: "handle",
    class: _vm.resizableHandleClass
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-f2ef9cd2!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/GridItem.vue
// module id = 27
// module chunks = 0